export const helpCenterCategoriesData = [
    {
        id: '0',
        name: 'Survey',
        articleCounts: 10,
    },
    {
        id: '1',
        name: 'Themes',
        articleCounts: 6,
    },
    {
        id: '2',
        name: 'Security',
        articleCounts: 17,
    },
    {
        id: '3',
        name: 'Integration',
        articleCounts: 9,
    },
    {
        id: '4',
        name: 'Media',
        articleCounts: 12,
    },
    {
        id: '5',
        name: 'Analytic',
        articleCounts: 18,
    },
    {
        id: '6',
        name: 'Chatbot',
        articleCounts: 3,
    },
    {
        id: '7',
        name: 'Commission',
        articleCounts: 8,
    },
]

export const helpCenterArticleListData = [
    {
        id: 'pWBKE_0UiQ',
        title: 'Things you need to know about configuring the theme',
        content:
            'Measuring programming progress by lines of code is like measuring aircraft building progress by weight. You cant have great software without a great team, and most software teams behave like dysfunctional families.',
        category: 'themes',
        authors: [
            {
                name: 'Ron Vargas',
                img: '/img/avatars/thumb-3.jpg',
            },
        ],
        starred: true,
        updateTime: '2 weeks ago',
        createdBy: 'Ron Vargas',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: '2tv0CboXfj',
        title: 'Understand the background of themes',
        content:
            'A hacker on a roll may be able to produce-in a period of a few months-something that a small development group (say, 7-8 people) would have a hard time getting together over a year. IBM used to report that certain programmers might be as much as 100 times as productive as other workers, or more.',
        category: 'themes',
        authors: [
            {
                name: 'Carolyn Hanson',
                img: '/img/avatars/thumb-9.jpg',
            },
            {
                name: 'Samantha Phillips',
                img: '/img/avatars/thumb-6.jpg',
            },
        ],
        starred: true,
        updateTime: '6 months ago',
        createdBy: 'Carolyn Hanson',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'XHpEwVPi4D',
        title: 'Basic tools you need to know on configuring the theme',
        content:
            'Its ridiculous to live 100 years and only be able to remember 30 million bytes. You know, less than a compact disc.  The human condition is really becoming more obsolete every minute.',
        category: 'themes',
        authors: [
            {
                name: 'Lloyd Obrien',
                img: '/img/avatars/thumb-11.jpg',
            },
        ],
        starred: false,
        updateTime: '4 months ago',
        createdBy: 'Lloyd Obrien',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: '09R6gIH5zD',
        title: 'Simple guidance for you in theming',
        content:
            'As soon as we started programming, we found to our surprise that it wasnt as easy to get programs right as we had thought. Debugging had to be discovered.  I can remember the exact instant when I realized that a large part of my life from then on was going to be spent in finding mistakes in my own programs.',
        category: 'themes',
        authors: [
            {
                name: 'Joyce Freeman',
                img: '/img/avatars/thumb-5.jpg',
            },
        ],
        starred: false,
        updateTime: '3 months ago',
        createdBy: 'Joyce Freeman',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'rZjCbSyae5',
        title: 'How to create a survey form',
        content:
            'Come to think of it, there are already a million monkeys on a million typewriters, and Usenet is nothing like Shakespeare',
        category: 'survey',
        authors: [
            {
                name: 'Terrance Moreno',
                img: '/img/avatars/thumb-2.jpg',
            },
        ],
        starred: true,
        updateTime: '3 months ago',
        createdBy: 'Terrance Moreno',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'mmPo6vqS1t',
        title: 'Survey form best practice',
        content:
            'Come to think of it, there are already a million monkeys on a million typewriters, and Usenet is nothing like Shakespeare',
        category: 'survey',
        authors: [
            {
                name: 'Luke Cook',
                img: '/img/avatars/thumb-4.jpg',
            },
            {
                name: 'Samantha Phillips',
                img: '/img/avatars/thumb-6.jpg',
            },
            {
                name: 'Joyce Freeman',
                img: '/img/avatars/thumb-5.jpg',
            },
        ],
        starred: false,
        updateTime: 'Last week',
        createdBy: 'Luke Cook',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: '6ETEWm8ZHt',
        title: 'Precious tips to help you create a better question',
        content:
            'Computer science education cannot make anybody an expert programmer any more than studying brushes and pigment can make somebody an expert painter. (Eric Raymond) The Internet? Is that thing still around?',
        category: 'survey',
        authors: [
            {
                name: 'Joyce Freeman',
                img: '/img/avatars/thumb-5.jpg',
            },
        ],
        starred: false,
        updateTime: '2 months ago',
        createdBy: 'Joyce Freeman',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'WQCy5CZcEJ',
        title: 'Quick tips regarding security',
        content:
            'It would appear that we have reached the limits of what it is possible to achieve with computer technology, although one should be careful with such statements, as they tend to sound pretty silly in 5 years.',
        category: 'security',
        authors: [
            {
                name: 'Tara Fletcher',
                img: '/img/avatars/thumb-7.jpg',
            },
        ],
        starred: false,
        updateTime: '4 months ago',
        createdBy: 'Tara Fletcher',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'prUH65MCWD',
        title: 'All You need to know about privacy setting',
        content:
            'As soon as we started programming, we found to our surprise that it wasnt as easy to get programs right as we had thought. Debugging had to be discovered.  I can remember the exact instant when I realized that a large part of my life from then on was going to be spent in finding mistakes in my own programs.',
        category: 'security',
        authors: [
            {
                name: 'Tara Fletcher',
                img: '/img/avatars/thumb-7.jpg',
            },
        ],
        starred: false,
        updateTime: '8 months ago',
        createdBy: 'Tara Fletcher',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: '1xK5PJRunm',
        title: 'Simple guide for integration',
        content:
            'Software undergoes beta testing shortly before its released. Beta is Latin for “still doesnt work”. (Anonymous) Come to think of it, there are already a million monkeys on a million typewriters, and Usenet is nothing like Shakespeare. Deleted code is debugged code. ',
        category: 'integration',
        authors: [
            {
                name: 'Frederick Adams',
                img: '/img/avatars/thumb-8.jpg',
            },
        ],
        starred: false,
        updateTime: '7 months ago',
        createdBy: 'Frederick Adams',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'iVB_L9xy2d',
        title: 'Most effective ways to overcome integration issue.',
        content:
            'A programmer is a person who passes as an exacting expert on the basis of being able to turn out, after innumerable punching, an infinite series of incomprehensive answers calculated with micrometric precisions from vague assumptions based on debatable figures taken from inconclusive documents and carried out on instruments of problematical accuracy by persons of dubious reliability and questionable mentality for the avowed purpose of annoying and confounding a hopelessly defenseless department that was unfortunate enough to ask for the information in the first place.',
        category: 'integration',
        authors: [
            {
                name: 'Gabriella May',
                img: '/img/avatars/thumb-12.jpg',
            },
            {
                name: 'Gail Barnes',
                img: '/img/avatars/thumb-14.jpg',
            },
        ],
        starred: true,
        updateTime: '3 days ago',
        createdBy: 'Gabriella May',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 't6D3gCV8hN',
        title: 'API document for integration',
        content:
            'For a long time it puzzled me how something so expensive, so leading edge, could be so useless. And then it occurred to me that a computer is a stupid machine with the ability to do incredibly smart things, while computer programmers are smart people with the ability to do incredibly stupid things.  They are, in short, a perfect match',
        category: 'integration',
        authors: [
            {
                name: 'Ella Robinson',
                img: '/img/avatars/thumb-15.jpg',
            },
        ],
        starred: false,
        updateTime: '2 weeks ago',
        createdBy: 'Gabriella May',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'gI3fhHZzoQ',
        title: 'Integration best practice',
        content:
            'Microsoft has a new version out, Windows XP, which according to everybody is the most reliable Windows ever. To me, this is like saying that asparagus is the most articulate vegetable ever. ',
        category: 'integration',
        authors: [
            {
                name: 'Lee Wheeler',
                img: '/img/avatars/thumb-13.jpg',
            },
        ],
        starred: false,
        updateTime: '3 weeks ago',
        createdBy: 'Lee Wheeler',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: '4zu-IVncIh',
        title: 'Managing media storage',
        content:
            'The citys central computer told you? R2D2, you know better than to trust a strange computer! (C3PO) 640K ought to be enough for anybody.',
        category: 'media',
        authors: [
            {
                name: 'Brittany Hale',
                img: '/img/avatars/thumb-10.jpg',
            },
        ],
        starred: true,
        updateTime: 'a year ago',
        createdBy: 'Brittany Hale',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: '4zu-WQX60M9MDJ',
        title: 'Beware of oversized',
        content:
            'One mans crappy software is another mans full-time job. (Jessica Gaston) Its a curious thing about our industry: not only do we not learn from our mistakes, but we also dont learn from our successes.',
        category: 'media',
        authors: [
            {
                name: 'Terrance Moreno',
                img: '/img/avatars/thumb-2.jpg',
            },
            {
                name: 'Brittany Hale',
                img: '/img/avatars/thumb-10.jpg',
            },
        ],
        starred: false,
        updateTime: 'a year ago',
        createdBy: 'Terrance Moreno',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'yHE5vZ4sow',
        title: 'Several effective ways to optimize media file',
        content:
            'Always code as if the guy who ends up maintaining your code will be a violent psychopath who knows where you live. Come to think of it, there are already a million monkeys on a million typewriters, and Usenet is nothing like Shakespeare.',
        category: 'media',
        authors: [
            {
                name: 'Ron Vargas',
                img: '/img/avatars/thumb-3.jpg',
            },
        ],
        starred: false,
        updateTime: '9 months ago',
        createdBy: 'Ron Vargas',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'CZZxidbzLi',
        title: 'Collecting data like a charm',
        content:
            'Programming is like sex: one mistake and youre providing support for a lifetime. It would appear that we have reached the limits of what it is possible to achieve with computer technology, although one should be careful with such statements, as they tend to sound pretty silly in 5 years.',
        category: 'analytic',
        authors: [
            {
                name: 'Luke Cook',
                img: '/img/avatars/thumb-4.jpg',
            },
        ],
        starred: true,
        updateTime: '3 months ago',
        createdBy: 'Luke Cook',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'aOuPn7DxZz',
        title: 'Simple guide for snapshot report',
        content:
            'If builders built buildings the way programmers wrote programs, then the first woodpecker that came along would destroy civilization. There are only two industries that refer to their customers as users',
        category: 'analytic',
        authors: [
            {
                name: 'Carolyn Hanson',
                img: '/img/avatars/thumb-9.jpg',
            },
        ],
        starred: false,
        updateTime: '4 months ago',
        createdBy: 'Carolyn Hanson',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: '90hXaTVMr3',
        title: 'Several ways to generate comparison report',
        content:
            'The trouble with programmers is that you can never tell what a programmer is doing until its too late. Most of you are familiar with the virtues of a programmer. There are three, of course: laziness, impatience, and hubris.  In order to understand recursion, one must first understand recursion.',
        category: 'analytic',
        authors: [
            {
                name: 'Carolyn Perkins',
                img: '/img/avatars/thumb-1.jpg',
            },
        ],
        starred: false,
        updateTime: '10 months ago',
        createdBy: 'Eileen Horton',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'bd3Hxes4NB',
        title: 'Add new customer service on chatbot',
        content:
            'It would appear that we have reached the limits of what it is possible to achieve with computer technology, although one should be careful with such statements, as they tend to sound pretty silly in 5 years. ',
        category: 'chatbot',
        authors: [
            {
                name: 'Terrance Moreno',
                img: '/img/avatars/thumb-2.jpg',
            },
        ],
        starred: false,
        updateTime: '2 months ago',
        createdBy: 'Terrance Moreno',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'zcZn3PBqKf',
        title: 'Configuring auto reply',
        content:
            'The function of good software is to make the complex appear to be simple. If the automobile had followed the same development cycle as the computer, a Rolls-Royce would today cost $100, get a million miles per gallon, and explode once a year, killing everyone inside.',
        category: 'chatbot',
        authors: [
            {
                name: 'Frederick Adams',
                img: '/img/avatars/thumb-8.jpg',
            },
        ],
        starred: false,
        updateTime: '5 months ago',
        createdBy: 'Frederick Adams',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'LWy8fEP-tA',
        title: 'Commission calculation',
        content:
            'In software, we rarely have meaningful requirements. Even if we do, the only measure of success that matters is whether our solution solves the customers shifting idea of what their problem is. The best method for accelerating a computer is the one that boosts it by 9.8 m/s2',
        category: 'commission',
        authors: [
            {
                name: 'Lee Wheeler',
                img: '/img/avatars/thumb-13.jpg',
            },
        ],
        starred: false,
        updateTime: '5 days ago',
        createdBy: 'Lee Wheeler',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'SAxrgvMuip',
        title: 'Export commission statement',
        content:
            'One mans crappy software is another mans full-time job. Its a curious thing about our industry: not only do we not learn from our mistakes, but we also dont learn from our successes. Measuring programming progress by lines of code is like measuring aircraft building progress by weight',
        category: 'commission',
        authors: [
            {
                name: 'Joyce Freeman',
                img: '/img/avatars/thumb-5.jpg',
            },
        ],
        starred: false,
        updateTime: 'a year ago',
        createdBy: 'Joyce Freeman',
        timeToRead: 2,
        viewCount: 37,
    },
    {
        id: 'NcUFsNDmUV',
        title: 'Commission policy',
        content:
            'Fine, Java MIGHT be a good example of what a programming language should be like. But Java applications are good examples of what applications SHOULDN’T be like. (pixadel) Fifty years of programming language research, and we end up with C++? ',
        category: 'commission',
        authors: [
            {
                name: 'Carolyn Perkins',
                img: '/img/avatars/thumb-1.jpg',
            },
            {
                name: 'Gabriella May',
                img: '/img/avatars/thumb-12.jpg',
            },
        ],
        starred: true,
        updateTime: 'a year ago',
        createdBy: 'Eileen Horton',
        timeToRead: 2,
        viewCount: 37,
    },
]
